import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Typography, Box } from '@mui/material';
import { CartProvider } from './contexts/CartContext';
import { ProductDescriptionProvider } from './contexts/ProductDescriptionContext';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import CategoryList from './components/Category/CategoryList';
import ProductDetail from './components/Product/ProductDetail';
import Cart from './components/Cart/Cart';
import BookingForm from './components/Booking/BookingForm';
import Payment from './components/Payment/Payment';
import AdminDashboard from './components/Admin/AdminDashboard';
import CategoryDetail from './components/CategoryDetail/CategoryDetail';
import AdminProducts from './components/Admin/AdminProducts/index';
import AdminReservations from './components/Admin/AdminReservations';
import PaymentReservation from './components/Payment/PaymentReservation';
import PaymentSuccess from './components/Payment/PaymentSuccess';
import Contact from './components/Contact/Contact';
import Layout from './components/Layout/Layout';
import Products from './components/Products/Products';
import Checkout from './components/Checkout/Checkout';
import AdminDates from './components/Admin/AdminDates';
import AdminCategories from './components/Admin/AdminCategories';
import Confirmation from './components/Reservation/Confirmation';
import AdminPlanning from './components/Admin/AdminPlanning';
import AdminSlotsSummary from './components/Admin/AdminSlotsSummary';
import AdminSlotsList from './components/Admin/AdminSlotsList';
import AdminOpenSlots from './components/Admin/AdminOpenSlots/AdminOpenSlots';
import AdminProductDescription from './components/Admin/AdminProductDescription';
import LegalMentions from './components/LegalMentions';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2',
        },
        secondary: {
            main: '#dc004e',
        },
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
});

function App() {
    return (
        <ErrorBoundary>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <CartProvider>
                <ProductDescriptionProvider>
                    <Router>
                        <Layout>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/categories" element={<CategoryList />} />
                                <Route path="/product/:id" element={<ProductDetail />} />
                                <Route path="/category/:slug" element={<CategoryDetail />} />
                                <Route path="/cart" element={<Cart />} />
                                <Route path="/booking" element={<BookingForm />} />
                                <Route path="/payment" element={<Payment />} />
                                <Route path="/payment/reservation" element={<PaymentReservation />} />
                                <Route path="/payment/success" element={<PaymentSuccess />} />

                                {/* Routes Admin Protégées */}
                                <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                                <Route path="/admin/products" element={<ProtectedRoute><AdminProducts /></ProtectedRoute>} />
                                <Route path="/admin/categories" element={<ProtectedRoute><AdminCategories /></ProtectedRoute>} />
                                <Route path="/admin/reservations" element={<ProtectedRoute><AdminReservations /></ProtectedRoute>} />
                                <Route path="/admin/dates" element={<ProtectedRoute><AdminDates /></ProtectedRoute>} />
                                <Route path="/admin/planning" element={<ProtectedRoute><AdminPlanning /></ProtectedRoute>} />
                                <Route path="/admin/slots-summary" element={<ProtectedRoute><AdminSlotsSummary /></ProtectedRoute>} />
                                <Route path="/admin/slots-list" element={<ProtectedRoute><AdminSlotsList /></ProtectedRoute>} />
                                <Route path="/admin/open-slots" element={<ProtectedRoute><AdminOpenSlots /></ProtectedRoute>} />
                                <Route path="/admin/product-description" element={<ProtectedRoute><AdminProductDescription /></ProtectedRoute>} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/legal" element={<LegalMentions />} />
                                <Route path="/products" element={<Products />} />
                                <Route path="/checkout" element={<Checkout />} />
                                <Route path="/confirmation" element={<Confirmation />} />
                                <Route path="*" element={
                                    <Box sx={{ p: 3, textAlign: 'center' }}>
                                        <Typography variant="h4" component="h1">
                                            Page non trouvée
                                        </Typography>
                                    </Box>
                                } />
                            </Routes>
                        </Layout>
                    </Router>
                </ProductDescriptionProvider>
            </CartProvider>
        </ThemeProvider>
        </ErrorBoundary>
    );
}

export default App;